import React from 'react'
import { UserMap } from '../../components/maps/MapCustom'
import { Box, IconButton, InputBase } from '@mui/material'
import { Search } from '@mui/icons-material'

import { FaCalendarAlt } from "react-icons/fa";
export const AmainLocation = () => {
  return (
    <div> 
         <div
        className=" d-flex justify-content-between align-items-center px-4 col-md-6"
        style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
      >
        <InputBase
          className=""
          sx={{
            ml: 1,
            flex: 1,
            px: 1,
          }}
          placeholder="Search..."
          type="search"
        />
        <Box
          sx={{
            width: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            type="button"
            sx={{
              p: "5px",
              backgroundColor: "#3E4755",
              color: "white",
              "&:hover": {
                backgroundColor: "#3E4755",
                color: "white",
              },
            }}
            aria-label="search"
          >
            <Search style={{ fontSize: 25 }} />
          </IconButton>
        </Box>
      </div>
        <h1 className='text-center my-3'> LOCATIONS</h1>
        
        
            <div className='rounded-4 px-4'  style={{ width: "100%", height: 510 ,position:"relative"}} >
    <UserMap />
    <div className="rounded-3 p-2 translate-middle gap-3 d-flex align-items-center " style={{backgroundColor:"white" ,display:"inline-block",position:"absolute", left:"50%" ,top:"30px",zIndex:"999999",border:"1px solid black"}}  > 
    {/* <FaCalendarAlt style={{fontSize:"23px"}} />
  <h4 className='m-0 mx-3'>01/10/2024</h4> */}
   <input className='' type="date" name="" id=""  style={{border:"0px",fontSize:"20px"}}/>
  </div>
  </div>
  
  
  
  </div>
  )
}
